import emailApi from '../../performance/services/emailApi';

// Unified helper for all check-in notifications
const postCheckInNotification = async (body) => {
  try {
    const result = await emailApi.sendCheckInNotification(body);
    console.log('✅ Check-in notification sent:', result);
    return result;
  } catch (error) {
    console.warn('📧 Check-in notification failed:', error);
    return { success: false, error: error.message };
  }
};

export const sendCheckInInitiatedEmail = async ({ staffName, staffEmail, staffId, periodLabel, financialYear, managerName }) => {
  return postCheckInNotification({
    actionType: 'initiated',
    staffId,
    staffEmail,
    staffName,
    periodLabel,
    financialYear,
    managerName
  });
};

export const sendCheckInSubmittedEmail = async ({ staffName, staffEmail, managerEmail, periodLabel, financialYear, staffId }) => {
  return postCheckInNotification({
    actionType: 'submitted',
    staffId,
    staffEmail: managerEmail, // Send to manager
    staffName,
    periodLabel,
    financialYear
  });
};

// ✅ Use the unified helper for reviewed notifications
export const sendCheckInReviewedEmail = (params) =>
  postCheckInNotification({ ...params, actionType: 'reviewed' });

// ✅ Use the unified helper for meeting scheduled notifications
export const sendMeetingScheduledEmail = (params) =>
  postCheckInNotification({ ...params, actionType: 'meeting_scheduled' });